export class OriginCheckService {
  private allowedOrigins: Set<string>;

  constructor(origins: string[]) {
    this.allowedOrigins = new Set();
    origins.forEach(origin => {
        this.addAllowedOrigin(origin);
    });
  }

  addAllowedOrigin(origin: string): void {
    this.allowedOrigins.add(origin);
    if (origin.endsWith('/')) {
      this.allowedOrigins.add(origin.slice(0, -1));
    } else {
      this.allowedOrigins.add(origin + '/');
    }
  }

  isOriginAllowed(origin: string): boolean {
    if (origin.startsWith('https://localhost')) {
      return true;
    }
    return this.allowedOrigins.has(origin);
  }
}
